import React from 'react'
import './categories.css'

function Categories() {
    return (
        <div id="categories" className="cat-container">
             
            <h2>Community Influence</h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt necessitatibus cumque laudantium dignissimos numquam accusantium perferendis delectus. Vero, quos reiciendis corrupti quisquam sunt vel amet at iure, eaque, optio nobis!</p>
            <div className="categories">
                <div className="row">
                    <div>
                        <img src="imgs/a.webp" alt="category item" />
                        <h3>Something here</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt necessitatibus cumque laudantium dignissimos numquam accusantium perferendis delectus. Vero</p>
                    </div>
                    <div>
                        <img src="imgs/c.webp" alt="category item" />
                        <h3>Title here</h3>
                        <p>Sunt necessitatibus cumque laudantium dignissimos numquam accusantium perferendis delectus. Vero</p>
                    </div>
                    <div>
                        <img src="imgs/terre.webp" alt="category item" />
                        <h3>The Title here</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt necessitatibus cumque laudantium dignissimos numquam accusantium perferendis delectus. Vero</p>
                    </div>
                 
                    <div>
                        <img src="imgs/forest.webp" alt="category item" />
                        <h3>category here</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt necessitatibus cumque laudantium dignissimos numquam accusantium perferendis delectus. Vero</p>
                    </div>
                    <div>
                        <img src='imgs/b.webp' alt="category item" />
                        <h3>category title</h3>
                        <p> itatibus cumque laudantium dignissimos numquam accusantium perferendis delectus. Vero</p>
                    </div>
                    <div>
                        <img src="imgs/terre.webp" alt="category item" />
                        <h3>category title here</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt necessitatibus cumque laudantium dignissimos numquam accusantium perferendis delectus. Vero</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Categories
